import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0df738a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-lg container-fluid py-4" }
const _hoisted_2 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_3 = { class: "my-3" }
const _hoisted_4 = { class: "card border-0 shadow" }
const _hoisted_5 = { class: "p-d-flex p-jc-between" }
const _hoisted_6 = { class: "p-input-icon-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_8 = { class: "p-text-center" }
const _hoisted_9 = { class: "p-text-center" }
const _hoisted_10 = { class: "p-buttonset" }
const _hoisted_11 = { class: "confirmation-content" }
const _hoisted_12 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("main", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_DataTable, {
          responsiveLayout: "scroll",
          breakpoint: "700px",
          value: _ctx.datas,
          paginator: true,
          loading: _ctx.loading,
          rows: 10,
          selectionMode: "single",
          columnResizeMode: "fit",
          scrollHeight: "flex",
          globalFilterFields: ['username', 'email'],
          filters: _ctx.filters,
          "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
          filterDisplay: "menu"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Button, {
                type: "button",
                icon: "pi pi-filter-slash",
                label: "Clear",
                class: "p-button-outlined",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearFilter())),
                "aria-label": "Clear filter"
              }),
              _createElementVNode("span", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_InputText, {
                  modelValue: _ctx.filters['global'].value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                  placeholder: "Keyword Search ..."
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          empty: _withCtx(() => [
            _createElementVNode("h6", _hoisted_8, "No " + _toDisplayString(_ctx.title) + " found.", 1)
          ]),
          loading: _withCtx(() => [
            _createElementVNode("h6", _hoisted_9, " Loading " + _toDisplayString(_ctx.title) + " data. Please wait. ", 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, { header: "#" }, {
              body: _withCtx(({ index }) => [
                _createTextVNode(_toDisplayString(index + 1), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "email",
              header: "Email",
              sortable: true,
              frozen: true
            }),
            _createVNode(_component_Column, {
              field: "username",
              header: "Username",
              sortable: true,
              frozen: false
            }),
            _createVNode(_component_Column, {
              field: "department",
              header: "Department",
              sortable: true,
              frozen: false
            }),
            _createVNode(_component_Column, {
              exportable: false,
              header: "Option",
              style: {"min-width":"4rem"}
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_Button, {
                    label: "View",
                    icon: "pi pi-id-card",
                    class: "p-button-sm p-button-raised mb-1 p-button-info",
                    onClick: ($event: any) => (_ctx.getOfficial(slotProps.data.id)),
                    "aria-label": "User Detail"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading", "filters"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.dataDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataDialog) = $event)),
      style: { width: '450px' },
      header: _ctx.data ? _ctx.data.username : 'Official',
      modal: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          icon: "pi pi-times",
          class: "p-button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataDialog = false)),
          "aria-label": "Close Dialog"
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          (_ctx.data)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.data.email), 1),
                _createElementVNode("h6", null, _toDisplayString(_ctx.data.department), 1),
                _createElementVNode("h6", null, _toDisplayString(_ctx.data.username), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}